import React, { createContext, useContext, useEffect, useState } from 'react';
import apis from '../api';

// Crea un Context per il token CSRF
const CSRFContext = createContext();

export const CSRFProvider = ({ children }) => {
    const [csrfToken, setCsrfToken] = useState('');

    useEffect(() => {
        // Ottieni il token CSRF quando il componente viene montato
        apis.getCsrfToken()
            .then(response => setCsrfToken(response.data.csrfToken))
            .catch(err => console.error('Errore nel recupero del token CSRF:', err));
    }, []);

    return (
        <CSRFContext.Provider value={csrfToken}>
            {children}
        </CSRFContext.Provider>
    );
};

export const useCSRFToken = () => useContext(CSRFContext);
